/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/*@ngInject*/
export default function GeoLocationDirective($compile, $templateCache, $translate, $mdUtil, $filter, types) {
    var linker = function (scope, element) {
        scope.types = types;

        $compile(element.contents())(scope);
    };

    return {
        restrict: "E",
        link: linker,
        scope: {
            location: '=',
            isEdit: '=',
            isReadOnly: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/geo-location/geo-location.directive.js